export const portalVersion = "5.0"; 
